<script>
import axios from 'axios'
import Note from '@components/tabs/note.vue'
import { downloadCSV } from '@utils/json-to-csv'

export default {
  components: { Note },
  data() {
    return {
      notes: null,
      loaded: false,
      noteForm: null,
    }
  },
  mounted() {
    this.getNotes()
  },
  methods: {
    getNotes() {
      axios
        .post(
          process.env.VUE_APP_KONSUL_API_URL + `/notes/user`,
          {
            userId: this.$auth.user.email,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$auth.user.access_token,
            },
          }
        )
        .then(
          (response) => {
            if (response.data.Items) {
              this.notes = response.data.Items
              this.notes
                .sort((x, y) => {
                  return x.created_at - y.created_at
                })
                .reverse()
            } else {
              this.notes = []
            }
            this.loaded = true
          },
          (err) => {
            return err
          }
        )
    },
    deleteNote(event) {
      const noteId = event.pk.replace('NOTE#', '')
      const userId = event.sk.replace('USER#', '')
      axios
        .delete(
          process.env.VUE_APP_KONSUL_API_URL + `/notes/${noteId}/${userId}`,
          {
            headers: {
              Authorization: 'Bearer ' + this.$auth.user.access_token,
            },
          }
        )
        .then(
          (_response) => {
            this.notes = this.notes.filter((i) => i.pk !== event.pk)
            this.loaded = true
          },
          (err) => {
            return err
          }
        )
    },
    exportNotes() {
      downloadCSV(this.notes)
    },
    save() {
      this.loaded = false
      axios
        .post(
          process.env.VUE_APP_KONSUL_API_URL + '/notes',
          {
            meta: this.noteForm,
            userId: this.$auth.user.email,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$auth.user.access_token,
            },
          }
        )
        .then(
          (_response) => {
            this.noteForm = null
            this.getNotes()
          },
          (err) => {
            this.loaded = true
            return err
          }
        )
    },
  },
}
</script>

<template>
  <div>
    <div v-if="!loaded" class="loader">
      <a-icon
        type="loading"
        style="padding-left: 8px; font-size: 24px; color: #1890ff"
        spin
      />
    </div>
    <div v-else-if="loaded && notes.length" class="notes--container">
      <Note :notes="notes" @delete-note="deleteNote($event)" />
      <div class="form--container">
        <a-textarea
          v-model="noteForm"
          placeholder="Enter notes here..."
          :auto-size="{ minRows: 3, maxRows: 5 }"
          @pressEnter="save"
        />
        <div class="button--container">
          <a-button
            type="primary"
            icon="download"
            style="width: 49%; margin-right: 1%"
            @click="exportNotes"
          >
            Export
          </a-button>
          <a-button
            type="primary"
            icon="enter"
            :disabled="!noteForm"
            style="width: 49%; margin-left: 1%"
            @click="save"
            >Submit
          </a-button>
        </div>
      </div>
    </div>
    <div v-else class="notes--container">
      <a-empty style="padding-top: 0.4rem" :description="'No Notes'" />
      <div class="form--container">
        <a-textarea
          v-model="noteForm"
          placeholder="Enter notes here..."
          :auto-size="{ minRows: 3, maxRows: 5 }"
          @pressEnter="save"
        />
        <div class="button--container">
          <a-button
            type="primary"
            :disabled="true"
            icon="download"
            style="width: 49%; margin-right: 1%"
            @click="exportNotes"
          >
            Export
          </a-button>
          <a-button
            type="primary"
            :disabled="!noteForm"
            style="width: 49%; margin-left: 1%"
            @click="save"
            >Submit
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.loader {
  padding: 2rem;
  text-align: center;
}

.button--container {
  width: 100%;
  margin-top: 8px;

  button {
    width: 100%;
  }
}

.form--container {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: white;
}

.notes--container {
  height: calc(100vh - 14.75rem);
  padding-bottom: 5rem;
  overflow-y: scroll;
}
</style>
